export type StageSlug = "extraction" | "management" | "execution";

/** A ordem dos três estágios do Configuration Server; o rodapé volta e avança por ela. */
export const STAGES: { slug: StageSlug; label: string }[] = [
  { slug: "extraction", label: "Extraction" },
  { slug: "management", label: "Management" },
  { slug: "execution", label: "Execution" },
];

/** O número do estágio (1 a 3): o mesmo do "Step X of 3" dos rodapés. */
export function stageStep(stage: StageSlug): number {
  return STAGES.findIndex((entry) => entry.slug === stage) + 1;
}
